import axios from "axios";
import { Constants } from "../utils/Constants";

const BASE_URL = `${Constants.baseUrl}/onboarding`;

export const getOnboarding = () => axios.get(BASE_URL);

export const salvarPasso = (data) => axios.post(`${BASE_URL}/passo`, data);

export const getTarifas = (cidade) =>
  axios.get(`${Constants.baseUrl}/tarifas`, { params: { cidade } });
